import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "wrapperStyles"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import { Tooltip as FlowbiteTooltip } from 'flowbite-react';
import { jsx as _jsx } from "react/jsx-runtime";

var StyledDiv = /*#__PURE__*/_styled.div.withConfig({
  displayName: "tooltip__StyledDiv",
  componentId: "sc-1wz7bxf-0"
})(["", " & > :first-child{", "}"], function (_ref) {
  var wrapperStyles = _ref.wrapperStyles;
  return wrapperStyles;
}, {
  "width": "100%"
});

export function Tooltip(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      wrapperStyles = _ref2.wrapperStyles,
      restProps = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/_jsx(StyledDiv, {
    wrapperStyles: wrapperStyles,
    children: /*#__PURE__*/_jsx(FlowbiteTooltip, _objectSpread(_objectSpread({
      className: className || 'max-w-[320px] text-center'
    }, restProps), {}, {
      children: children
    }))
  });
}
export default Tooltip;